/**
 * 物件一覧: PC エリア変更モーダル（.js-bukken-list-area-modal-open）
 * SP: タブ付きフィルターモーダル（.js-bukken-list-sp-filter-modal-open）
 * 投資・事業用: 専用 PC/SP モーダル（#bukken-list-area-modal--investment / #bukken-list-sp-filter-modal--investment）
 */
export function init() {
	const mqPc = window.matchMedia('(min-width: 768px)');
	const mqSp = window.matchMedia('(max-width: 767px)');

	const pcModal = document.getElementById('bukken-list-area-modal');
	const spModal = document.getElementById('bukken-list-sp-filter-modal');
	const investmentPcModal = document.getElementById('bukken-list-area-modal--investment');
	const spInvestmentModal = document.getElementById('bukken-list-sp-filter-modal--investment');

	function setPcModalsInertForSp() {
		[pcModal, investmentPcModal].forEach((m) => {
			if (!m) return;
			if (mqSp.matches) {
				m.setAttribute('inert', '');
			} else {
				m.removeAttribute('inert');
			}
		});
	}

	setPcModalsInertForSp();
	mqSp.addEventListener('change', () => setPcModalsInertForSp());

	/* ----- PC 通常 ----- */
	if (pcModal) {
		const openBtns = document.querySelectorAll('.js-bukken-list-area-modal-open');
		const overlay = pcModal.querySelector('.js-bukken-list-area-modal-overlay');
		const closeBtn = pcModal.querySelector('.js-bukken-list-area-modal-close');

		function closePcModal() {
			pcModal.setAttribute('hidden', '');
			document.body.style.overflow = '';
		}

		function openPcModal() {
			pcModal.removeAttribute('hidden');
			document.body.style.overflow = 'hidden';
			closeBtn?.focus();
		}

		openBtns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				if (!mqPc.matches) return;
				e.preventDefault();
				openPcModal();
			});
		});

		overlay?.addEventListener('click', closePcModal);
		closeBtn?.addEventListener('click', closePcModal);
	}

	/* ----- PC 投資 ----- */
	if (investmentPcModal) {
		const invOpenBtns = document.querySelectorAll('.js-bukken-list-investment-pc-modal-open');
		const invOverlay = investmentPcModal.querySelector('.js-bukken-list-investment-pc-modal-overlay');
		const invCloseBtn = investmentPcModal.querySelector('.js-bukken-list-investment-pc-modal-close');
		const invModeRadios = investmentPcModal.querySelectorAll('.js-bukken-investment-pc-mode');
		const invPanels = investmentPcModal.querySelectorAll('.js-bukken-investment-pc-panel');

		function setInvestmentPcMode(mode) {
			const m = mode === 'line' ? 'line' : 'area';
			invModeRadios.forEach((r) => {
				r.checked = r.value === m;
			});
			invPanels.forEach((p) => {
				const show = p.dataset.bukkenInvestmentPcPanel === m;
				p.hidden = !show;
			});
		}

		function closeInvestmentPcModal() {
			investmentPcModal.setAttribute('hidden', '');
			document.body.style.overflow = '';
		}

		function openInvestmentPcModal(mode) {
			setInvestmentPcMode(mode);
			investmentPcModal.removeAttribute('hidden');
			document.body.style.overflow = 'hidden';
			invCloseBtn?.focus();
		}

		invOpenBtns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				if (!mqPc.matches) return;
				e.preventDefault();
				const mode = btn.dataset.bukkenInvestmentPcMode === 'line' ? 'line' : 'area';
				openInvestmentPcModal(mode);
			});
		});

		invModeRadios.forEach((r) => {
			r.addEventListener('change', () => {
				if (r.checked) setInvestmentPcMode(r.value);
			});
		});

		invOverlay?.addEventListener('click', closeInvestmentPcModal);
		invCloseBtn?.addEventListener('click', closeInvestmentPcModal);
	}

	function closeSpModal() {
		if (!spModal) return;
		spModal.setAttribute('hidden', '');
		document.body.style.overflow = '';
	}

	/* ----- SP 通常タブモーダル ----- */
	if (spModal) {
		const spOpenBtns = document.querySelectorAll('.js-bukken-list-sp-filter-modal-open');
		const spCloseBtn = spModal.querySelector('.js-bukken-list-sp-filter-modal-close');
		const tabBtns = spModal.querySelectorAll('[data-bukken-sp-filter-tab]');
		const panelArea = document.getElementById('bukken-list-sp-panel-area');
		const panelConditions = document.getElementById('bukken-list-sp-panel-conditions');

		function setSpTab(tab) {
			tabBtns.forEach((btn) => {
				const t = btn.dataset.bukkenSpFilterTab;
				const active = t === tab;
				btn.classList.toggle('is-active', active);
				btn.setAttribute('aria-selected', active ? 'true' : 'false');
			});
			if (panelArea) {
				const show = tab === 'area';
				panelArea.hidden = !show;
				panelArea.classList.toggle('is-active', show);
			}
			if (panelConditions) {
				const show = tab === 'conditions';
				panelConditions.hidden = !show;
				panelConditions.classList.toggle('is-active', show);
			}
		}

		function openSpModal(tab) {
			setSpTab(tab === 'conditions' ? 'conditions' : 'area');
			spModal.removeAttribute('hidden');
			document.body.style.overflow = 'hidden';
			const activeTab = spModal.querySelector('.bukkenListSpFilterModal__tab.is-active');
			activeTab?.focus();
		}

		spOpenBtns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				if (!mqSp.matches) return;
				e.preventDefault();
				const tab = btn.dataset.bukkenSpFilterTab === 'conditions' ? 'conditions' : 'area';
				openSpModal(tab);
			});
		});

		spCloseBtn?.addEventListener('click', closeSpModal);

		tabBtns.forEach((btn) => {
			btn.addEventListener('click', () => {
				const tab = btn.dataset.bukkenSpFilterTab;
				if (tab === 'area' || tab === 'conditions') {
					setSpTab(tab);
				}
			});
		});
	}

	function closeSpInvestmentModal() {
		if (!spInvestmentModal) return;
		spInvestmentModal.setAttribute('hidden', '');
		document.body.style.overflow = '';
	}

	/* ----- SP 投資タブモーダル ----- */
	if (spInvestmentModal) {
		const spInvOpenBtns = document.querySelectorAll('.js-bukken-list-sp-filter-modal-investment-open');
		const spInvCloseBtn = spInvestmentModal.querySelector('.js-bukken-list-sp-filter-modal-investment-close');
		const primaryTabBtns = spInvestmentModal.querySelectorAll('[data-bukken-sp-investment-primary]');
		const panelGeo = document.getElementById('bukken-list-sp-investment-panel-geo');
		const panelConditions = document.getElementById('bukken-list-sp-investment-panel-conditions');
		const geoSubRadios = spInvestmentModal.querySelectorAll('.js-bukken-sp-investment-geo-submode');
		const geoSubPanels = spInvestmentModal.querySelectorAll('.js-bukken-sp-investment-geo-subpanel');

		function setSpInvestmentGeoSubmode(mode) {
			const m = mode === 'line' ? 'line' : 'area';
			geoSubRadios.forEach((r) => {
				r.checked = r.value === m;
			});
			geoSubPanels.forEach((p) => {
				const show = p.dataset.bukkenSpInvestmentGeoSubpanel === m;
				p.hidden = !show;
			});
		}

		function setSpInvestmentPrimary(primary) {
			const p = primary === 'conditions' ? 'conditions' : 'geo';
			primaryTabBtns.forEach((btn) => {
				const t = btn.dataset.bukkenSpInvestmentPrimary;
				const active = t === p;
				btn.classList.toggle('is-active', active);
				btn.setAttribute('aria-selected', active ? 'true' : 'false');
			});
			if (panelGeo) {
				const show = p === 'geo';
				panelGeo.hidden = !show;
				panelGeo.classList.toggle('is-active', show);
			}
			if (panelConditions) {
				const show = p === 'conditions';
				panelConditions.hidden = !show;
				panelConditions.classList.toggle('is-active', show);
			}
		}

		function openSpInvestmentModal(primary) {
			setSpInvestmentPrimary(primary === 'conditions' ? 'conditions' : 'geo');
			if (primary !== 'conditions') {
				setSpInvestmentGeoSubmode('area');
			}
			spInvestmentModal.removeAttribute('hidden');
			document.body.style.overflow = 'hidden';
			const activeTab = spInvestmentModal.querySelector('.bukkenListSpFilterModal__tab.is-active');
			activeTab?.focus();
		}

		spInvOpenBtns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				if (!mqSp.matches) return;
				e.preventDefault();
				const primary = btn.dataset.bukkenSpInvestmentPrimary === 'conditions' ? 'conditions' : 'geo';
				openSpInvestmentModal(primary);
			});
		});

		spInvCloseBtn?.addEventListener('click', closeSpInvestmentModal);

		primaryTabBtns.forEach((btn) => {
			btn.addEventListener('click', () => {
				const t = btn.dataset.bukkenSpInvestmentPrimary;
				if (t === 'geo' || t === 'conditions') {
					setSpInvestmentPrimary(t);
				}
			});
		});

		geoSubRadios.forEach((r) => {
			r.addEventListener('change', () => {
				if (r.checked) setSpInvestmentGeoSubmode(r.value);
			});
		});
	}

	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape') return;
		if (spInvestmentModal && !spInvestmentModal.hasAttribute('hidden')) {
			closeSpInvestmentModal();
			return;
		}
		if (spModal && !spModal.hasAttribute('hidden')) {
			closeSpModal();
			return;
		}
		if (investmentPcModal && !investmentPcModal.hasAttribute('hidden') && mqPc.matches) {
			investmentPcModal.setAttribute('hidden', '');
			document.body.style.overflow = '';
			return;
		}
		if (pcModal && !pcModal.hasAttribute('hidden') && mqPc.matches) {
			pcModal.setAttribute('hidden', '');
			document.body.style.overflow = '';
		}
	});
}
